import axios from "./axios";
import { server, store, apiUrl } from "./constants";

// ===========================================
// =  Store Manager Function (Seller/Store)  =
// ===========================================

/**
 * Create store
 * @param {FormData} value contain {storeName, bank, bankID, cardImage, bankImage}
 * @returns {{success: boolean}}
 */
const createStore = async (value) => {
    // const result = await axios.post('token', value);
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const result = await axios.post(store.CREATE_STORE_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return result.data;
}

/**
 * Get products by sellerID
 * @param {*} sellerID 
 * @returns {{animals?: [object], petfoods?: [object], supplies?: [object]}}
 */
const getProductsBySellerID = async (sellerID) => {
    const result = await axios.get(`${server.GET_PRODUCT_BY_MYSTORE_URL}/${sellerID}`);
    return result.data;
}

/**
 * Create new product
 * @param {FormData} value Consist of 'title, description, price, stock, images'
 * @return {{success: boolean}}
 */
const createProduct = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    let result = await axios.post(store.STORE_PRODUCT_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return result.data;
}

/**
 * Delete product from store
 * @param {String} param
 * @returns {{success: boolean}}
 */
const deleteProduct = async (_id) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const result = await axios.delete(`${store.STORE_PRODUCT_URL}/${_id}`, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return result.data;
}

/**
 * Update new product
 * @param {String} _id Product ID
 * @param {FormData} value Consist of 'title, description, price, stock, images'
 * @return {{success: boolean}}
 */
const updateProduct = async (_id, value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    let result = await axios.put(`${store.STORE_PRODUCT_URL}/${_id}`, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return result.data;
}

const getStoreInfo = async () => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.get(store.STORE_INFO_URL, {
        headers: { 'Authorization': `be ${accessToken}` }
    })
    return data;
}

/**
 * Update Store
 * @param {FormData} value 
 * @returns 
 */
const updateStoreInfo = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.put(store.STORE_INFO_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    })
    return data;
}

export default {
    createStore,
    getProductsBySellerID,
    createProduct,
    deleteProduct,
    updateProduct,
    getStoreInfo,
    updateStoreInfo,
}